<script>
    import { onMount } from "svelte";
    import { business } from "../../firebase/auth";
    export let card;

    $: columns = Math.round(Math.sqrt(card.stampCount));
    $: rows = Math.ceil(card.stampCount / columns);

    console.log(card);
</script>

{#if columns && rows}
<div class="card {card.published&&!card.archived?"active":""}">
    <div class="header">
        <div class="avatar">
            <img src="" alt="">
        </div>
        <div class="business">
            <span class="name">{card.name}</span>
            <span class="location">Stempelkarte</span>
        </div>
        <div class="actions">

        </div>
    </div>
    <div class="main" style={"grid-template-columns: repeat(" + columns +", calc((100% - " + (columns - 1) +" * 0.5rem) / "+columns+")); grid-template-rows: repeat("+ rows +", calc((100% - " + (rows - 1) +" * 0.5rem) / "+rows+"));"}>
        {#each Array(card.stampCount) as stamp, i}
            <div class="stamp-field">
                {#if i <= card.stampCount/2}
                    {#if $business}
                        <img style={"transform: rotate(-" + (Math.random()*20) + "deg)"} src={$business.images?.stamp} alt="">
                    {/if}
                {/if}
            </div>
        {/each}
    </div>
</div>
{/if}

<style>
    .card {
        width: 15rem;
        height: 25rem;
        background-color: white;
        border-radius: 0.5rem;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        outline: 1px solid rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
    }

    .header {
        width: 100%;
        height: 3.5rem;
        /* border-bottom: 1px solid #F1E9E1; */
        padding: 0.5rem;
        display: flex;
        box-sizing: border-box;
    }

    .avatar {
        border-radius: 1.5rem;
        height: 2.5rem;
        width: 2.5rem;
        background-color: rgba(0, 0, 0, 0.05);
    }

    .business {
        margin-left: 0.5rem;
        display: flex;
        flex-direction: column;
        color: #032B43;
    }

    .name {
        font-weight: bold;
    }

    .location {
        font-size: 0.8rem;
    }

    .main {
        padding: 0.5rem;
        flex: 1;
        height: 100%;
        display: grid;
        justify-content: fill;
        align-content: center;
        gap: 0.5rem;
    }

    .stamp-field {
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 0.5rem;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 5%;
    }

    .stamp-field img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>